document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  const banner = header?.querySelector('[x-ref="banner"]') || document.querySelector('.banner-wrapper');
  const nav = header?.querySelector('.navbar');
  const menuContainer = header?.querySelector('.header-primary-menu-container');
  const ham = header?.querySelector('.ham');
  const menuButton = header?.querySelector('button[aria-label="Valikkopainike"]');

  /* ---- Scroll logic ---- */
  const updateScrolled = () => {
    if (!banner || !nav) return;

    // 1. Calculate the base trigger point
    const bannerBottom = banner.offsetTop + banner.offsetHeight;

    // 2. Use the same offset on every screen size
    const offset = 433;

    // 3. Trigger earlier (bannerBottom - offset)
    const shouldScroll = window.scrollY > (bannerBottom - offset);

    nav.classList.toggle('scrolled', shouldScroll);
  };

  window.addEventListener('scroll', updateScrolled, { passive: true });
  window.addEventListener('resize', updateScrolled);
  updateScrolled(); // initial state

  /* ---- Mobile menu toggle ---- */
  if (menuButton && menuContainer && ham) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuContainer.classList.contains('open');
      menuContainer.classList.toggle('open', !isOpen);
      menuContainer.classList.toggle('flex', !isOpen);
      menuContainer.classList.toggle('hidden', isOpen);
      ham.classList.toggle('active', !isOpen);
    });

    // Close menu automatically on resize ≥1280px
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1280 && menuContainer.classList.contains('open')) {
        menuContainer.classList.remove('open', 'flex');
        menuContainer.classList.add('hidden');
        ham.classList.remove('active');
      }
    });
  }

});